// extracted by mini-css-extract-plugin
export default {"container":"style_container__lbdB8","arrow":"style_arrow__3Gfli"};